module.exports = __webpack_public_path__ + "img/Iran_Venezuela.35821593.svg";